module.exports = __webpack_public_path__ + "static/media/blue.ad6226ed.jpg";